import addProductImages from "./addProductImages";
import fetchImages from "./fetchImages";

export default async function initImages(win: WindowProxy) {
  const products: HTMLElement = win.document.querySelectorAll(`.product-tile`);
  const productCodes: Array = [...products].map((product: HTMLElement) => parseFloat(product.dataset.productCode));
  const images = await fetchImages(productCodes);
  addProductImages(products, images);
}



// WEBPACK FOOTER //
// ./javascript/product-search-page/image-fetch/index.js